export const extractDomain = (baseServer) => {
  let domain = "";
  if (typeof window !== "undefined") {
    const url = window.location.origin;
    if (baseServer) {
      domain = baseServer;
    } else if (url.includes("localhost") || url.includes("test")) {
      domain = "https://recruiter.foundit.in";
    } else {
      domain = window.location.origin;
    }
  }
  return domain;
};

export const MIDDLEWARE = "/edge/dashboard/middleware";
export const API_HEADERS = {
  domain: extractDomain(),
};
export function transformQuestions(inputData, inputData2 = null) { 
    if (!inputData) return {};

    let sourceData = inputData2 ? inputData2.candidateQuestionnaire || {} : inputData;
console.log("sourceData",sourceData)
    let transformedData = {
        "Passing Marks": inputData2 ? String(inputData2.score || "") : (inputData["Passing Marks"] || ""),
        "Questionnaire Description": inputData["Questionnaire Description"] || "",
        "Questionnaire Name": inputData["Questionnaire Name"] || "",
        "Questions": []
    };

    let questionsArray = [];
    let longQuestion = null;

    Object.keys(sourceData)
        .sort((a, b) => {
            let numA = a.match(/\d+/) ? parseInt(a.match(/\d+/)[0], 10) : Infinity;
            let numB = b.match(/\d+/) ? parseInt(b.match(/\d+/)[0], 10) : Infinity;
            return numA - numB;
        })
        .forEach(key => {
            if (key.startsWith("Question") && sourceData[key] !== null && typeof sourceData[key] === "object") {
                let questionData = sourceData[key];

                let transformedQuestion = {
                    "question": questionData.question,
                    "points": String(questionData.marks || "0")
                };

                if ("answer" in questionData && (questionData.answer === "yes" || questionData.answer === "no")) {
                    transformedQuestion["value"] = questionData.answer;
                    transformedQuestion["option"] = questionData.answer === "yes" ? "A" : "B";
                    transformedQuestion["type"] = "Objective";
                } else {
                    transformedQuestion["value"] = questionData.answer || null;
                    transformedQuestion["type"] = "Descriptive";
                }

                questionsArray.push(transformedQuestion);
            } 
            else if ((key === "LongQuestion" || key === "Long Question") && sourceData[key] !== null && typeof sourceData[key] === "object") {
                console.log("LongQuestion",key,sourceData,sourceData[key])
                let questionData = sourceData[key];

                if (questionData.question && questionData.question.trim().length > 0) {
                    longQuestion = {
                        "question": questionData.question,
                        "points": String(questionData.marks || "0"),
                        "value": questionData.answer || null,
                        "type": "Descriptive"
                    };
                }
            }
        });

    questionsArray.forEach((q, index) => q.id = index + 1);

    if (longQuestion) {
        longQuestion.id = questionsArray.length + 1;
        questionsArray.push(longQuestion);
    }

    transformedData.Questions = questionsArray;
    
    return transformedData;
}

export function extractDesignation(current_employment) {
    if (!current_employment) return null;
    let employment = Array.isArray(current_employment) ? current_employment[0] : current_employment;

    if (!employment || !employment.designation) return null;

    return typeof employment.designation === "string"
        ? employment.designation
        : employment.designation.text || null; 
}

export function getTimeAgo(timestamp) {
    const now = new Date();
    const past = new Date(timestamp);
    const diffInSeconds = Math.floor((now - past) / 1000);
  
    if (diffInSeconds < 15) {
      return 'just now';
    } else if (diffInSeconds < 60) {
      return `${diffInSeconds} sec ago`;
    }
  
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} min ago`;
    }
  
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return diffInHours === 1 ? '1 hour ago' : `${diffInHours} hours ago`;
    }
  
    const diffInDays = Math.floor(diffInHours / 24);
    return diffInDays === 1 ? '1 day ago' : `${diffInDays} days ago`;
  }
  